// extracted by mini-css-extract-plugin
module.exports = {"Select":"DenContent_Select__nbzVW","DenContent":"DenContent_DenContent__1P2Vk"};